"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RevertedInDocumentIndicator = exports.REVERTED_IN_DOCUMENT_TITLE = exports.REVERTED_IN_DOCUMENT_LABEL = exports.PartlyRevertedInDocumentIndicator = exports.PARTLY_REVERTED_IN_DOCUMENT_TITLE = exports.PARTLY_REVERTED_IN_DOCUMENT_LABEL = void 0;
var _react = _interopRequireDefault(require("react"));
var _lucideReact = require("lucide-react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var REVERTED_IN_DOCUMENT_LABEL = exports.REVERTED_IN_DOCUMENT_LABEL = "Reverted";
var REVERTED_IN_DOCUMENT_TITLE = exports.REVERTED_IN_DOCUMENT_TITLE = "This change was applied, then taken back in the document. Apply it again to restore it.";
var PARTLY_REVERTED_IN_DOCUMENT_LABEL = exports.PARTLY_REVERTED_IN_DOCUMENT_LABEL = "Partly reverted";
var PARTLY_REVERTED_IN_DOCUMENT_TITLE = exports.PARTLY_REVERTED_IN_DOCUMENT_TITLE = "This change was applied, then part of it was taken back in the document.";
var RevertedInDocumentIndicator = exports.RevertedInDocumentIndicator = function RevertedInDocumentIndicator() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
    className: "flex items-center gap-1 text-[11px] font-medium text-[#92400E]",
    role: "status",
    title: REVERTED_IN_DOCUMENT_TITLE,
    "data-sentry-component": "RevertedInDocumentIndicator",
    "data-sentry-source-file": "RevertedInDocumentIndicator.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_lucideReact.RotateCcw, {
      size: 13,
      className: "flex-shrink-0",
      "aria-hidden": "true",
      "data-sentry-element": "RotateCcw",
      "data-sentry-source-file": "RevertedInDocumentIndicator.tsx"
    }), REVERTED_IN_DOCUMENT_LABEL]
  });
};
var PartlyRevertedInDocumentIndicator = exports.PartlyRevertedInDocumentIndicator = function PartlyRevertedInDocumentIndicator() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
    className: "flex items-center gap-1 text-[11px] font-medium text-[#92400E]",
    role: "status",
    title: PARTLY_REVERTED_IN_DOCUMENT_TITLE,
    "data-sentry-component": "PartlyRevertedInDocumentIndicator",
    "data-sentry-source-file": "RevertedInDocumentIndicator.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_lucideReact.RotateCcw, {
      size: 13,
      className: "flex-shrink-0",
      "aria-hidden": "true",
      "data-sentry-element": "RotateCcw",
      "data-sentry-source-file": "RevertedInDocumentIndicator.tsx"
    }), PARTLY_REVERTED_IN_DOCUMENT_LABEL]
  });
};